export const ETAT_ENREGISTRE = 'EnCours';
export const ETAT_CLOTURER = 'Clos';
export const ETAT_REALISE = 'Realise';

export const TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE = 'OrdreTravail';
export const TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE = 'OrdreTravailTechnique';
export const TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION = 'OrdreTravailTechniqueImpression';
export const TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_POSE = 'OrdreTravailTechniquePose';
export const TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_FABRICATION = 'OrdreTravailTechniqueFabrication';
export const TYPE_EDITION_ORDRE_TRAVAIL_MAIL = 'ordreTravailTechnique';
export const TYPE_EDITION_ORDRE_AFFICHAGE_MAIL = 'ordreAffichage';

export const LISTE_ETAT_ORDRE_TRAVAIL = [
  { code: ETAT_ENREGISTRE, libelle: 'listeOrdreTravailAffichage.etat.enregistre' },
  { code: ETAT_CLOTURER, libelle: 'listeOrdreTravailAffichage.etat.clos' },
  { code: ETAT_REALISE, libelle: 'listeOrdreTravailAffichage.etat.realise' },
];

export const LIST_ICON_AND_COLOR = [
  { class: 'has-background-annonceur-1', icon: 'alpha-a-box' },
  { class: 'has-background-annonceur-2', icon: 'alpha-b-box' },
  { class: 'has-background-annonceur-3', icon: 'alpha-c-box' },
  { class: 'has-background-annonceur-4', icon: 'alpha-d-box' },
  { class: 'has-background-annonceur-5', icon: 'alpha-e-box' },
  { class: 'has-background-annonceur-6', icon: 'alpha-f-box' },
  { class: 'has-background-annonceur-1', icon: 'alpha-g-box' },
  { class: 'has-background-annonceur-2', icon: 'alpha-h-box' },
  { class: 'has-background-annonceur-3', icon: 'alpha-i-box' },
  { class: 'has-background-annonceur-4', icon: 'alpha-j-box' },
  { class: 'has-background-annonceur-5', icon: 'alpha-k-box' },
  { class: 'has-background-annonceur-6', icon: 'alpha-l-box' },
  { class: 'has-background-annonceur-1', icon: 'alpha-m-box' },
  { class: 'has-background-annonceur-2', icon: 'alpha-n-box' },
  { class: 'has-background-annonceur-3', icon: 'alpha-o-box' },
  { class: 'has-background-annonceur-4', icon: 'alpha-p-box' },
  { class: 'has-background-annonceur-5', icon: 'alpha-q-box' },
  { class: 'has-background-annonceur-6', icon: 'alpha-r-box' },
  { class: 'has-background-annonceur-1', icon: 'alpha-s-box' },
  { class: 'has-background-annonceur-2', icon: 'alpha-t-box' },
  { class: 'has-background-annonceur-3', icon: 'alpha-u-box' },
  { class: 'has-background-annonceur-4', icon: 'alpha-v-box' },
  { class: 'has-background-annonceur-5', icon: 'alpha-w-box' },
  { class: 'has-background-annonceur-6', icon: 'alpha-x-box' },
];

export const OT_AVEC_LAISSER_EN_PLACE = 'OtAvecLaisserEnPlace';
export const OT_AVEC_DETAIL_MANUEL = 'OtAvecDetailManuel';
export const OT_AVEC_RESEAU = 'OtAvecReseau';

export const LISTE_CHOICE_EDITION_OT = [
  {
    typeEdition: OT_AVEC_LAISSER_EN_PLACE,
    libelle: 'detailOrdreTravailAffichage.popUpEdition.otAvecLaisserEnPlace',
    typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
    value: true,
  },
  {
    typeEdition: OT_AVEC_DETAIL_MANUEL,
    libelle: 'detailOrdreTravailAffichage.popUpEdition.otAvecDetailManuel',
    typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
    value: false,
  },
  {
    typeEdition: OT_AVEC_RESEAU,
    libelle: 'detailOrdreTravailAffichage.popUpEdition.otAvecReseau',
    typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
    value: false,
  },
];

export const ETAT_EN_ATTENTE = 'EnAttente';
export const ETAT_EN_COURS = 'EnCours';
export const ETAT_ANNULE = 'Annule';
export const ETAT_PLANIFIE = 'Planifie';
export const ETAT_A_EXPEDIER = 'AExpedier';
export const ETAT_EXPEDIE = 'Expedie';
export const ACTION_MASS_EXPEDITION = 'ExpedierEnMasse';
export const ACTION_MASS_A_EXPEDIER = 'AExpedierEnMasse';
export const ACTION_MASS_REALISE = 'RealiseEnMasse';
export const ACTION_MASS_PRENDRE_EN_CHARGE = 'PrendreEnChargeEnMasse';
export const LIST_ETAT_OT_TECH = [
  { code: ETAT_EN_ATTENTE, libelle: 'listeOrdreTravailTech.etat.enAttente' },
  { code: ETAT_EN_COURS, libelle: 'listeOrdreTravailTech.etat.enCours' },
  { code: ETAT_ANNULE, libelle: 'listeOrdreTravailTech.etat.annule' },
  { code: ETAT_REALISE, libelle: 'listeOrdreTravailTech.etat.realise' },
  { code: ETAT_PLANIFIE, libelle: 'listeOrdreTravailTech.etat.planifie' },
  { code: ETAT_CLOTURER, libelle: 'listeOrdreTravailAffichage.etat.clos' },
  { code: ETAT_A_EXPEDIER, libelle: 'listeOrdreTravailTech.etat.aExpedier' },
  { code: ETAT_EXPEDIE, libelle: 'listeOrdreTravailTech.etat.expedie' },
];

export const EXPORT_EXCEL_ORDRE_TRAVAIL = 'ordretravailtechnique';

export const INDEX_REGROUPEMENT_MANUEL = -1;
export const EXPORT_EXCEL_ORDRE_TRAVAIL_AFFICHAGE = 'ordretravail';

export const TYPE_EXPORT = 'detailOt';

export const COULEUR_OT_ETAT = [
  { key: ETAT_EN_COURS, type: 'has-text-colorOrange' },
  { key: ETAT_REALISE, type: 'has-text-colorVert' },
];

export const EDITION_BON_LIVRAISON = 'BonLivraison';

export const ACTION_EDITION_BON_LIVRAISON = 'BonLivraison';

export const ACTION_MASS_AFFICHER_NE_PAS_AFFICHER = 'AfficherNePasAfficher';
export const ACTION_MASS_LAISSER_NE_PAS_LAISSER = 'LaisserEnPlaceNePasLaisserEnPlace';
export const ACTION_MASS_GRATTER_NE_PAS_GRATTER = 'GratterNePasGratter';

export const AFFICHAGE = 'Affichage';
export const LAISSERENPLACE = 'LaisserEnPlace';
